import { useState } from 'react';
import { Root } from '@radix-ui/react-toolbar';
import { styled } from 'styled-components';
import Logo from 'components/Logo';
import HelpLink from 'components/HelpLink';
import UserMenu from './UserMenu';

const NavWrapper = styled(Root)`
  width: 100vw;
  height: 100px;
  background: rgba(255 255 255 / 88%);
  box-shadow: rgba(19 37 59 / 10%) 0 4px 50px 0;
  backdrop-filter: blur(10px);
  padding: 30px 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: sticky;
`;

const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
`;

/**
 * Toolbar
 *
 * @param {object} props - the component's props
 * @param {Array} props.portfolios - the user's portfolios
 * @param {object} props.user - the user object
 *
 * @returns {JSX.Element} - the homepage toolbar component
 */
export default function Toolbar({ portfolios, user }) {
  const [activeOrg, setActiveOrg] = useState(user?.organizations[0]);
  return (
    <NavWrapper>
      <Logo variant="light" />
      <ButtonWrapper>
        <HelpLink variant="light" />
        <UserMenu
          portfolios={portfolios}
          user={user}
          activeOrg={activeOrg}
          onSelect={setActiveOrg}
        />
      </ButtonWrapper>
    </NavWrapper>
  );
}
